import React from "react";
import {Link, LinkProps, useLocation} from "react-router-dom";
import './linkwrapper.scss';


type Props = {
    hasLink?: boolean;
    keepSearchParams?: boolean;
} & LinkProps

const LinkWrapper: React.FC<Props> = ({hasLink = true, className, children, ...linkProps}) => {
    const location = useLocation();

    if (hasLink) {
        return (
            <Link
                className={`linkwrapper ${className}`}
                {...linkProps}
                to={`${linkProps.to}${location.search}`}
            >
                {children}
            </Link>
        )
    }

    return (
        <div className={className}>
            {children}
        </div>
    )
}

export default LinkWrapper;